import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/fanCommunity";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header className="fixed inset-x-0 top-0 z-50 transition-colors duration-300">
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-b border-background-200"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <nav className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6 h-16 md:h-[72px]">
          {/* brand */}
          <a href="#home" className="flex items-center gap-2.5 shrink-0 group">
            <span className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-music-2-line text-lg md:text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-base md:text-lg font-bold tracking-wide transition-colors ${
                  light ? "text-background-50" : "text-foreground-950"
                }`}
              >
                吃瓜捷克
              </span>
              <span
                className={`font-display text-[10px] md:text-[11px] tracking-wide transition-colors ${
                  light ? "text-background-100/90" : "text-primary-600"
                }`}
              >
                ChiguaJieke Fan
              </span>
            </span>
          </a>

          {/* desktop links */}
          <ul className="hidden md:flex items-center gap-1 lg:gap-2">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className={`px-3 lg:px-4 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                    light
                      ? "text-background-50 hover:bg-white/15"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  }`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          {/* actions */}
          <div className="flex items-center gap-2">
            <a
              href="#join"
              className={`hidden sm:inline-flex whitespace-nowrap items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                light
                  ? "bg-background-50 text-primary-700 hover:bg-background-100"
                  : "bg-primary-500 text-background-50 hover:bg-primary-600"
              }`}
            >
              <i className="ri-team-line" />
              加入社群
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className={`md:hidden flex h-10 w-10 items-center justify-center rounded-full transition-colors cursor-pointer ${
                light ? "text-background-50 hover:bg-white/15" : "text-foreground-800 hover:bg-background-200"
              }`}
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
            </button>
          </div>
        </nav>

        {/* mobile menu */}
        {open && (
          <div className="md:hidden border-t border-background-200 bg-background-50/98 backdrop-blur">
            <ul className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="flex items-center justify-between rounded-lg px-3 py-3 text-foreground-800 hover:bg-background-100"
                  >
                    {l.label}
                    <i className="ri-arrow-right-s-line text-foreground-400" />
                  </a>
                </li>
              ))}
              <li className="pt-1">
                <a
                  href="#join"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-center gap-1.5 rounded-lg bg-primary-500 px-3 py-3 text-background-50 font-medium"
                >
                  <i className="ri-team-line" />
                  加入吃瓜捷克粉丝社群
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}